module.exports = __webpack_public_path__ + "img/logo clinical 5.f4b0f0e6.png";